module.exports = __webpack_public_path__ + "static/media/ic-activate-your-digital-super-powers.cfc36dec.svg";